import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  HeaderContainer,
  StepIndicator,
  BackButton,
  StepsWrapper,
  Step,
  StepNumber,
  StepLabel,
  StepConnector,
} from './StyledComponents';

const StepHeader = ({
  currentStep,
  steps,
  backPath = '/admin-track/customers',
  backLabel = 'Back to Customers',
  onBack,
}) => {
  const history = useHistory();

  const handleBackClick = () => {
    // If onBack handler is provided, always use it (allows parent to control navigation)
    if (onBack) {
      onBack();
    } else if (currentStep === 1) {
      // Fallback: Navigate to previous page if no handler provided
      history.push(backPath);
    }
  };

  // Dynamic back label
  const getBackLabel = () => {
    if (currentStep === 1) {
      return backLabel;
    }
    return 'Back';
  };

  return (
    <HeaderContainer>
      <StepIndicator>
        <BackButton onClick={handleBackClick}>
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          <span className="back-label">{getBackLabel()}</span>
        </BackButton>
        <StepsWrapper>
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <Step
                active={currentStep === index + 1}
                completed={currentStep > index + 1}
              >
                <StepNumber
                  active={currentStep === index + 1}
                  completed={currentStep > index + 1}
                >
                  {currentStep > index + 1 ? '✓' : index + 1}
                </StepNumber>
                <StepLabel
                  active={currentStep === index + 1}
                  completed={currentStep > index + 1}
                >
                  {step}
                </StepLabel>
              </Step>
              {index < steps.length - 1 && (
                <StepConnector completed={currentStep > index + 1} />
              )}
            </React.Fragment>
          ))}
        </StepsWrapper>
        <div className="spacer"></div> {/* Spacer for centering */}
      </StepIndicator>
    </HeaderContainer>
  );
};

StepHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  backPath: PropTypes.string,
  backLabel: PropTypes.string,
  onBack: PropTypes.func,
};

export default StepHeader;
